import React from "react";
import "css/loader.css";
import { useLoading } from "context/LoadingContext";

export default function Loader() {
  const [loadingContext] = useLoading();
  const { loading } = loadingContext;
  if (!loading) return null;
  return (
    <div className="loader">
      <span>|</span>
      <span style={{ "--delay": " 0.1s" }}>|</span>
      <span style={{ "--delay": "0.3s" }}>|</span>
      <span style={{ "--delay": "0.4s" }}>|</span>
      <span style={{ "--delay": " 0.5s" }}>|</span>
    </div>
  );
}
